export default __webpack_public_path__ + "static/media/SecurityPapersLogo.29b758e5.jpg";